import { DossierShellMetricProfile } from '../create-dossier-states-definition';
import {
  DossierMetricProfile,
  dossierEconomicParticipantProfile,
  dossierEmployedProfile,
  dossierGvaProfile,
  resolveDossierHeadingLabel,
  resolveDossierHeadingLabels,
  dossierRevenueProfile,
  dossierTaxedProfile,
} from '../dossier-metric.profile';
import { DashboardDossierStatesDevelopmentViewConfig } from './dashboard-dossier-states-development.definition';

/**
 * Development-shell metric profile: shared dossier metric core +
 * development view.
 */
export type DossierDevelopmentMetricProfile = DossierShellMetricProfile<
  DashboardDossierStatesDevelopmentViewConfig
>;

const valueKey = 'value';
const valueChangePctKey = 'value_change_pct';

function fromShared(
  shared: DossierMetricProfile,
  shell: {
    view: DashboardDossierStatesDevelopmentViewConfig;
  },
): DossierDevelopmentMetricProfile {
  return {
    ...shared,
    ...shell,
  };
}

export const dossierDevelopmentTaxedProfile: DossierDevelopmentMetricProfile =
  fromShared(dossierTaxedProfile, {
    view: {
      valueKey,
      valueChangePctKey,
      timeKey: 'year',
      metricKey: dossierTaxedProfile.valueLabelKey,
      popupValueLabel: (d: any) =>
        `Gesamtanzahl der ${d[dossierTaxedProfile.valueLabelKey]}`,
      popupValueChangeLabel: () => 'Wachstum',
      valueFormat: 'number',
    },
  });

export const dossierDevelopmentRevenueProfile: DossierDevelopmentMetricProfile =
  fromShared(dossierRevenueProfile, {
    view: {
      valueKey,
      valueChangePctKey,
      timeKey: 'year',
      metricKey: dossierRevenueProfile.valueLabelKey,
      popupValueLabel: (d: any) =>
        `Gesamtbranchenumsatz der ${d[dossierRevenueProfile.valueLabelKey]}`,
      popupValueChangeLabel: () => 'Umsatzwachstum',
      valueFormat: 'currency',
    },
  });

export const dossierDevelopmentGvaProfile: DossierDevelopmentMetricProfile =
  fromShared(dossierGvaProfile, {
    view: {
      valueKey,
      valueChangePctKey,
      timeKey: 'year',
      metricKey: dossierGvaProfile.valueLabelKey,
      popupValueLabel: (d: any) =>
        d[dossierGvaProfile.valueLabelKey] ?? dossierGvaProfile.base.labels.shortLabel,
      popupValueChangeLabel: (d: any) =>
        `Wachstum ${resolveDossierHeadingLabel(
          resolveDossierHeadingLabels(dossierGvaProfile, d[dossierGvaProfile.valueLabelKey]),
          'genitive',
        )}`,
      valueFormat: 'currency',
    },
  });

export const dossierDevelopmentEconomicParticipantProfile: DossierDevelopmentMetricProfile =
  fromShared(dossierEconomicParticipantProfile, {
    view: {
      valueKey,
      valueChangePctKey,
      timeKey: 'year',
      metricKey: dossierEconomicParticipantProfile.valueLabelKey,
      popupValueLabel: (d: any) =>
        `Anzahl der ${d[dossierEconomicParticipantProfile.valueLabelKey]}n`,
      popupValueChangeLabel: () => 'Wachstum',
      valueFormat: 'number',
    },
  });

export const dossierDevelopmentEmployedProfile: DossierDevelopmentMetricProfile =
  fromShared(dossierEmployedProfile, {
    view: {
      valueKey,
      valueChangePctKey,
      timeKey: 'year',
      metricKey: dossierEmployedProfile.valueLabelKey,
      popupValueLabel: (d: any) =>
        `Anzahl der ${d[dossierEmployedProfile.valueLabelKey]}n`,
      popupValueChangeLabel: () => 'Wachstum',
      valueFormat: 'number',
    },
  });
